import { CACHE_TAGS } from "@acme/utils/cache-tags";
import { createFileRoute } from "@tanstack/react-router";
import { InnerCta } from "~/components/inside/inner-cta";
import { PageLabel } from "~/components/inside/page-intro";
import Projects from "~/components/projects/projects";
import { taggedCacheHeaders } from "~/lib/cache-headers";
import { seo } from "~/lib/seo";
import { $getAllPublicProjects } from "~/lib/server/project";
import {
  generateStructuredDataGraph,
  getProjectListSchemas,
} from "~/lib/structured-data";
import * as m from "~/paraglide/messages.js";
import { getLocale } from "~/paraglide/runtime.js";

export const Route = createFileRoute("/(public)/projects/")({
  component: RouteComponent,
  head: () => {
    const seoData = seo({
      description: m.meta_projects_description(),
      keywords:
        "AI systems case studies, business automation examples, custom internal tools, small business software projects, Lindevo work",
      path: "/projects",
      title: m.meta_projects_title(),
    });
    const structuredData = generateStructuredDataGraph(getProjectListSchemas());

    return {
      links: seoData.links,
      meta: seoData.meta,
      scripts: [
        {
          children: structuredData,
          type: "application/ld+json",
        },
      ],
    };
  },
  headers: taggedCacheHeaders(CACHE_TAGS.projects),
  loader: async () => {
    const projects = await $getAllPublicProjects({
      data: { locale: getLocale() },
    });
    return { projects };
  },
});

function RouteComponent() {
  const { projects } = Route.useLoaderData();

  return (
    <>
      <div className="wrap">
        {/* No scene band: the listing itself is the opening, headed by the
            two-column header the export draws. */}
        <header className="portfolio-heading">
          <div>
            <PageLabel>{m.projects_label()}</PageLabel>
            <h1>
              {m.projects_title_1()}
              <br />
              {m.projects_title_2()}
            </h1>
          </div>
          <p>{m.projects_intro()}</p>
        </header>

        <Projects projects={projects} />
      </div>

      <InnerCta
        lede={m.projects_cta_lede()}
        note={m.projects_cta_note()}
        title={m.projects_cta_title()}
      />
    </>
  );
}
